import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PagesService } from '@digilize/shared/data/services/src';
import { ItemSection, ItemTitle, Multilingual, SurveyPage } from '@digilize/shared/definitions/src';
import { TranslocoService } from '@jsverse/transloco';
import { first, map, Observable } from 'rxjs';

@Component({
  selector: 'suc-accordion-nav',
  templateUrl: './accordion-nav.component.html',
  styleUrls: ['./accordion-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccordionNavComponent implements OnInit {
  pages$: Observable<SurveyPage[]>;
  surveyResearchItemPageId$: Observable<string>;
  constructor(
    private pagesService: PagesService,
    private translocoService: TranslocoService
  ) {}
  MAX_LOGS = 10;
  logCounter = 0;
  ngOnInit(): void {
    this.pages$ = this.pagesService.pages$;
    this.surveyResearchItemPageId$ = this.pagesService.surveyResearchPageIds$.pipe(
      map((res) => res.itemPageId),
      first()
    );
  }

  getTitleOfSection(itemSection: ItemSection) {
    let itemTitle: ItemTitle;
    itemSection.items.forEach((item) => {
      if (!item.items) {
        throw new Error(`No elements in ${item.id} - check cms`);
      }

      item.items.forEach((nestedItem) => {
        if (nestedItem.kind === 'itemtitle') {
          itemTitle = nestedItem;
        }
      });
    });

    return this.getText(itemTitle?.title);
  }

  isSection(itemPageEl) {
    return itemPageEl.kind === 'itemsection';
  }

  logEmptyTitle(text: string) {
    if ((text === '' || text === undefined) && this.MAX_LOGS > this.logCounter) {
      this.logCounter++;
      console.warn('Empty title for current language, check cms panel');
    }
  }
  getText(multi: Multilingual | undefined): string {
    const text = multi?.[this.translocoService.getActiveLang() as keyof Multilingual];

    this.logEmptyTitle(text);
    return text;
  }
}
